import {
  FC,
  JSX,
  ReactNode,
} from "react";
import { View, Text } from "react-native";
import Skeleton from "@/app/components/Skeleton";

export interface ListItems {
  label: string;
  value?: string | ReactNode | null;
}

export interface IListProps {
  items: ListItems[];
  isLoading?: boolean;
}

const List: FC<IListProps> = ({ items, isLoading }): JSX.Element => {
  const renderValueOrSkeleton = (value?: ReactNode) => {
    if (isLoading) return <Skeleton />;
    
    const displayValue = (() => {
      if (value === null || value === undefined) return "Информация отсутствует";
      if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return String(value);
      if (typeof value === "object" && "$$typeof" in value) return value;
      if (typeof value === "object") {
        if (Array.isArray(value)) return value.length > 0 ? `Найдено записей: ${value.length}` : "Информация отсутствует";

        return "Информация отсутствует";
      }
      
      return String(value);
    })();

    return typeof displayValue === "object" && "$$typeof" in displayValue
      ? displayValue
      : <Text className="text-base text-left">{displayValue}</Text>;
  };

  const renderListItems = (): JSX.Element[] => items.map(({ label, value }: ListItems, i: number) => {
    const isLastItem: boolean = i === items.length - 1;

    return <View className={!isLastItem ? "mb-4" : ""} key={i}>
      <Text className="mb-1 text-base text-left text-gray">{label}</Text>
      {renderValueOrSkeleton(value)}
    </View>
  });

  return (
    <>
      {renderListItems()}
    </>
  );
};

export default List;
